<template>
  <div v-if="isObject">
    <b-modal
      :id="modalID"
      size="xl"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      header-class="card-header-padding"
      class="fullscreen-modal">
      <template v-slot:modal-header="{ close }" style="padding: 0 !important">
        <b-dropdown size="sm" v-model="chartType" @change="switchChart()" variant="default" no-caret="">
          <template v-slot:button-content>
            <b-icon icon="bar-chart-fill" font-scale="2"></b-icon>
          </template>
          <b-dropdown-item v-for="item in supportedCharts" :key="item.label" @click="switchChart()" v-bind:value="item.value">{{ item.label }}</b-dropdown-item>
        </b-dropdown>
        <select v-if="isObject" class="form-control" v-model="selectedItem" @change="redrawChart()"
          style="width: 30%">
          <option v-for="item in selectOptions" :key="item.label" v-bind:value="item">{{ item }}</option>
        </select>
        <b-button size="sm" class="pull-right" variant="default" @click="close()">
          <b-icon icon="x-circle" font-scale="2"></b-icon>
        </b-button>
      </template>
      <b-button v-b-toggle.collapse-1 size="sm" variant="primary" @click="toggleFilterForm()">Show/Hide Filter</b-button>

      <b-collapse id="collapse-1" class="mt-2">
        <categorical-filter-form :v-if="!!dashboardId && !!reportId"
        :v-show="showFilterForm"
        :dashboard-id="dashboardId"
        :dashboard="dashboard"
        :report-id="reportId"
        :filter-details="filterDetails"
        @filter="processData"
        @loading="updateLoadingSpinner">
      </categorical-filter-form>
      </b-collapse>

      <categorical-modal-insight
        :chart-options="chartOptions"
        :width-columns="widthColumns"
        :selected-chart-type="chartType">
      </categorical-modal-insight>
    </b-modal>

    <div
      v-masonry-tile
      v-if="hasData"
      :class="`insight d-inline-block insight-cols-${this.widthColumns}`"
      style="vertical-align: top; padding: 0 !important; margin: 0 !important;">
      <b-card
        header-tag="header"
        header-class="card-header-padding"
        class="card-style">
        <template v-slot:header style="padding: 0 !important">
          <select v-if="isObject" class="form-control pull-left" v-model="selectedItem" @change="redrawChart()"
            style="width: 30%">
            <!-- <option>Choose field</option> -->
            <option v-for="item in selectOptions" :key="item.label" v-bind:value="item">{{ item }}</option>
          </select>
          <b-dropdown class="pull-right" size="sm" v-model="chartType" @change="switchChart()" variant="default" no-caret="">
            <template v-slot:button-content>
              <b-icon icon="bar-chart-fill"></b-icon>
            </template>
            <b-dropdown-item v-for="item in supportedCharts" :key="item.label" @click="switchChart()" v-bind:value="item.value">{{ item.label }}</b-dropdown-item>
          </b-dropdown>
          <p class="h4 pull-right">
            <b-button v-b-toggle.collapse-2 size="sm" variant="default" @click="toggleDescription()">
              <b-icon icon="info" class="rounded-circle" variant="default"></b-icon>
            </b-button>
            <b-button variant="default" v-b-modal="modalID">
              <b-icon icon="arrows-fullscreen"></b-icon>
            </b-button>
          </p>
        </template>

        <b-collapse id="collapse-2" class="mt-2">
          <p style="text-align: center; color: #06f"><strong>Description</strong></p>
          <p style="text-align: center">{{this.description}}</p>
          <hr />
        </b-collapse>
        <!-- <chart :options="chartOptions" style="[isArray && isObject ? {'height': '80%; position: relative;'} : {'height: 100%; position: relative;'}]" /> -->
        <chart :options="chartOptions" style="height: 100%; position: relative;" />
      </b-card>
    </div>
  </div>
  <div v-else>
    <b-modal
      :id="modalID"
      size="xl"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      header-class="card-header-padding"
      dialog-class="fullscreen-modal card-header-padding"
      style="max-width: 100%; margin: 0; top: 0; bottom: 0; left: 0; right: 0; height: 100vh; display: flex;">
      <template v-slot:modal-header="{ close }" style="padding: 0 !important">
        <b-dropdown class="pull-right" size="sm" v-model="chartType" @change="switchChart()" variant="default" no-caret="">
          <template v-slot:button-content>
            <b-icon icon="bar-chart-fill" font-scale="2"></b-icon>
          </template>
          <b-dropdown-item v-for="item in supportedCharts" :key="item.label" @click="switchChart()" v-bind:value="item.value">{{ item.label }}</b-dropdown-item>
        </b-dropdown>
        <b-button size="sm" class="pull-right" variant="default" @click="close()">
          <b-icon icon="x-circle" font-scale="2"></b-icon>
        </b-button>
      </template>

      <b-button v-b-toggle.collapse-1 size="sm" variant="primary" @click="toggleFilterForm()">Show/Hide Filter</b-button>

      <b-collapse id="collapse-1" class="mt-2">
        <categorical-filter-form :v-if="!!dashboardId && !!reportId"
        :v-show="showFilterForm"
        :dashboard-id="dashboardId"
        :dashboard="dashboard"
        :report-id="reportId"
        :filter-details="filterDetails"
        @filter="processData"
        @loading="updateLoadingSpinner">
      </categorical-filter-form>
      </b-collapse>

      <loading-spinner v-if="loading" />
      <chart v-if="!loading" :options="chartOptions" style="height: 100%; position: relative;" />
    </b-modal>

    <div
      v-masonry-tile
      v-if="hasData"
      :class="`insight d-inline-block insight-cols-${this.widthColumns}`"
      style="vertical-align: top; padding: 0 !important; margin: 0 !important; position: relative !important">
      <b-card
        header-tag="header"
        header-class="card-header-padding"
        class="card-style">
        <template v-slot:header style="padding: 0 !important">
          <b-dropdown class="pull-right" size="sm" v-model="chartType" @change="switchChart()" variant="default" no-caret="">
            <template v-slot:button-content>
              <b-icon icon="bar-chart-fill"></b-icon>
            </template>
            <b-dropdown-item v-for="item in supportedCharts" :key="item.label" @click="switchChart()" v-bind:value="item.value">{{ item.label }}</b-dropdown-item>
          </b-dropdown>
          <p class="h4 pull-right">
            <b-button v-b-toggle.collapse-2 size="sm" variant="default" @click="toggleDescription()">
              <b-icon icon="info" class="rounded-circle" variant="default"></b-icon>
            </b-button>
            <b-button variant="default" v-b-modal="modalID">
              <b-icon icon="arrows-fullscreen"></b-icon>
            </b-button>
            <b-button variant="default" v-b-toggle="`collapse-chart-${collapseID}`" class="m-1 pull-right" @click="toggleChart()">
              <b-icon icon="arrow-up-circle"></b-icon>
            </b-button>
          </p>
          <!-- <p class="h4 pull-right">
            <b-button @click="goToLink()" variant="default" v-b-modal="modalID">
              <b-icon icon="arrows-fullscreen"></b-icon>
            </b-button>
          </p> -->
        </template>

        <b-collapse id="collapse-2" class="mt-2">
          <p style="text-align: center;"><strong style="color: #0af">Description</strong>: {{this.description}}</p>
          <hr />
        </b-collapse>
        <chart :options="chartOptions" style="height: 100%; position: relative;" />
      </b-card>
    </div>
  </div>
</template>

<script>
  // import CategoricalInsightContainer from './CategoricalInsightContainer';
  import {Chart} from 'highcharts-vue';
  import LoadingSpinner from "../LoadingSpinner";
  import CategoricalModalInsight from './CategoricalModalInsight';
  import CategoricalFilterForm from './CategoricalFilterForm';
  import HighChartsDrillDown from 'highcharts/modules/drilldown'
  import {maybeMissingValueLabel, lowerCase, titleCase} from './utils';
  import {CATEGORICAL_INSIGHT_HEIGHT} from './utils';
  import Highcharts from 'highcharts'
  import loadDrillDown from 'highcharts/modules/drilldown'
  import {round} from "lodash/math";
  import moment from "moment";
  import {saveActivity} from "@/utils";
  loadDrillDown(Highcharts)


  export default {
    name: 'CategoricalInsight',

    components: {
      Chart,
      CategoricalFilterForm,
      CategoricalModalInsight,
      LoadingSpinner
    },

    props: {
      values: Array,
      dashboardId: String,
      dashboard: Object,
      reportId: String,
      name: String,
      description: String,
      isString: Boolean,
      isArray: Boolean,
      isObject: Boolean,
      title: {
        type: String,
        default: "Count"
      },
      xlabel: String,
      xlabeltype: String,
      ylabel: String,
      defaultChart: String,
      drilldown: Boolean,
      grouped: Boolean,
      subtitle: String,
      width: Number,
      growthrate: Boolean,
      filterDetails: Array,
      dataValueLabel: String
    },
    drilldowndataglobal: [],

    data() {
      const currency = this.$store.state.general.currency;
      return {
        groups: [],
        groupNames: [],
        groupView: null,
        showFilterForm: false,
        showDescription: false,
        selectedItem: "",
        chartType: "",
        chartTitle: "",
        chartFilterData: null,
        chartData: this.values,
        exportOptions: {},
        loading: false,
        currency_placeholder: "currency_placeholder",
        currency_symbol_placeholder: "currency_symbol_holder",
        currency: currency
      };
    },

    mounted() {
      if (typeof this.$redrawVueMasonry === 'function') {
        this.$redrawVueMasonry()
      }
    },

    methods: {
      checkIfObject(x) {
        if ((typeof x === "object" || typeof x === 'function') && (x !== null)) {
          return true;
        }
        return false;
      },

      redrawChart() {
        this.chartTitle = this.name + " - " + this.selectedItem;
        this.chartData = this.chartData[this.selectedItem];
        return this.chartOptions;
      },

      switchChart() {
        this.chartType = event.target.text;
        if (this.chartType === 'line') this.chartType = 'spline';
        if (this.chartType === 'area') this.chartType = 'areaspline';
        if (this.chartType === 'pie') console.log("Data: ", this.chartData);
        return this.chartOptions;
      },

      toggleDescription() {
        this.showDescription = (!!this.showDescription) ? false : true;
      },

      toggleFilterForm() {
        this.showFilterForm = (!!this.showFilterForm) ? false : true;
      },

      abbreviateNumber(number) {
        var SI_SYMBOL = ["", "k", "M", "B", "T", "P", "E"];
        var tier = Math.log10(number) / 3 | 0;
        if(tier == 0) {
          if (number % 1 !== 0) {
            return round(number, 1)
          }
          return number;
        }
        var suffix = SI_SYMBOL[tier];
        var scale = Math.pow(10, tier * 3);
        var scaled = number / scale;
        return scaled.toFixed(1) + suffix;
      },

      generateData(data) {
        let seriesData = []
        let label = ""
        data.forEach(element => {
          seriesData.push({name: element.name,  y: element.count, label: this.abbreviateNumber(element.count),
            drilldown: element.id})
          label = element.label
          element.children = Object.values(element.children)
        })
        if (this.drilldowndataglobal === undefined) {
          this.drilldowndataglobal = []
        }
        this.generateDrillDownData(data)

        return [{name: label, colorByPoint: true, data: seriesData}, this.drilldowndataglobal]
      },

      generateDrillDownData(data) {
        data.forEach(element => {
          if (element["children"] === undefined) {
          } else {
            if (!Array.isArray(element.children)) {
              element.children = Object.values(element.children)
            }
            this.drilldowndataglobal.push({name: element.name, id: element.id, data: this.getDrillDownData(element)})
            this.generateDrillDownData(element.children)
          }
        })
        return true
      },

      getDrillDownData(element) {
        let data = []
        if (element["children"] !== undefined) {
          element.children.forEach(child => {
            let drilldown = null
            if (child["children"] !== undefined) {
              drilldown = child.id
            }
            data.push({name: child.name, y: child.count, label: this.abbreviateNumber(child.count),
              drilldown: drilldown })
          })
        }
        return data
      },

      formatDateText(month_year) {
        let month_names = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        let month_names_short = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        if (month_year && month_year.indexOf("-") > -1) {
          let res = month_year.split("-");
          return month_names[res[1] - 1] + " " + res[2] + " " + res[0];
        }
        else if (month_year && month_year.indexOf("/") > -1) {
          let res = month_year.split("/");
          return month_names_short[res[0] - 1] + " " + res[1];
        }
        return month_year;
      },

      sortByMonthYearDate(a, b) {
        a = a["_id"];
        b = b["_id"];
        var as = a.split('/'),
            bs = b.split('/'),
            ad = new Date(as[0]+' 1,'+as[1]),
            bd = new Date(bs[0]+' 1,'+bs[1]);
        return ad.getTime() - bd.getTime();
      },

      processData(value, event) {
        let data = value['data'];
        let report_id = value['id'];
        let dashboard_id = value['dashboard_id'];
        data = this.processChartData(data, report_id);
        // this.chartFilterData = data.value;
        this.chartData = data.value;
        this.loading = false
        return this.chartOptions;
      },

      // this.sortByMonthYearDate
      processChartData(data, id) {
        let report_id = id;
        let position = 0;
        let group_name = null;

        if (group_name) {
          if (group_name in this.groups) {
            this.groups[group_name].push(report_id)
          } else {
            this.groups[group_name] = [report_id]
            this.groupNames.push({text: group_name.toUpperCase(), value: group_name})
          }
        }
        let enabled = true
        if (this.groupView !== null) {
          enabled = this.groupView === group_name
        }

        if (data.report_type === 'chart') {
          if (data.chart_config.drill_down && data.chart_config.subtitle) {
            return {
              "id": report_id,
              "dashboard_id": this.dashboardId,
              "position": position,
              "title": data.title,
              "config": data.chart_config,
              "value": data.chart_data.data,
              "group_name": group_name,
              "enabled": enabled
            };
          }
          else if (data.chart_config.grouped) {
            for (let d = 0; d < data.chart_data.data.categories.length; d++) {
              data.chart_data.data.categories[d] = this.formatDateText(data.chart_data.data.categories[d])
            }
            return {
              "id": report_id,
              "dashboard_id": this.dashboardId,
              "position": position,
              "title": data.title,
              "config": data.chart_config,
              "value": data.chart_data.data,
              "group_name": group_name,
              "enabled": enabled
            };
          }
          else {
            if (data.chart_config.xlabeltype && data.chart_config.xlabeltype.toLowerCase() === "date") {
              data.chart_data.data.sort(this.sortByMonthYearDate);
            }
            return {
              "id": report_id,
              "dashboard_id": this.dashboardId,
              "position": position,
              "title": data.title,
              "config": data.chart_config,
              "value": data.chart_data.data.map(e => ([this.formatDateText(e['_id']), round(e['count'])])),
              "group_name": group_name,
              "enabled": enabled
            };
          }
        }
      },

      defaultExportOptions() {
        let context = this
        return {
          buttons: {
            contextButton: {
              menuItems: [
                'printChart',
                'separator',
                'downloadPNG',
                'downloadJPEG',
                'downloadPDF',
                'downloadSVG',
                'separator',
                'downloadCSV',
                'downloadXLS',
                'viewData'
              ]
            }
          },
          menuItemDefinitions: {
            'downloadPNG': {
              onclick: function () {
                  this.exportChart({type:"image/png"});
                  saveActivity("Downloaded the " + this.title.textStr + " report in png format", "data_download" , false)

                },
              text: 'Download PNG Image'
            },
            'downloadJPEG': {
              onclick: function () {
                  this.exportChart({type:"image/jpeg"});
                  saveActivity("Downloaded the " + this.title.textStr + " report in jpeg format", "data_download" , false)

                },
              text: 'Download JPEG Image'
            },
            'downloadPDF': {
              onclick: function () {
                  this.exportChart({type:"application/pdf"});
                  saveActivity("Downloaded the " + this.title.textStr + " report in pdf format", "data_download" , false)

                },
              text: 'Download PDF Document'
            },
            'downloadSVG': {
              onclick: function () {
                  this.exportChart({type:"image/svg+xml"});
                  saveActivity("Downloaded the " + this.title.textStr + " report in svg format", "data_download" , false)

                },
              text: 'Download SVG Vector Image'
            },
            'downloadCSV': {
              onclick: function () {
                  this.downloadCSV();
                  saveActivity("Downloaded the " + this.title.textStr + " report in csv format", "data_download" , false)

                },
              text: 'Download CSV'
            },
            'downloadXLS': {
              onclick: function () {
                  this.downloadXLS();
                  saveActivity("Downloaded the " + this.title.textStr + " report in xls format", "data_download" , false)

                },
              text: 'Download XLS'
            },
            'viewData': {
              onclick: function () {
                let viewDataElem = this.exportDivElements[9]
                if (!this.dataTableDiv || this.dataTableDiv.style.display === '' ||
                  this.dataTableDiv.style.display === 'none') {
                  this.viewData()
                  viewDataElem.innerHTML = "Hide Data Table"
                } else {
                  this.hideData()
                  viewDataElem.innerHTML = "View Data Table"
                }
                },
              text: 'View Data Table'
            }
          }
        };
      },

      getPointCategoryName(point, dimension) {
        let series = point.series,
        isY = dimension === 'y',
        axis = series[isY ? 'yAxis' : 'xAxis'];
        return axis.categories[point[isY ? 'y' : 'x']];
      },

      updateLoadingSpinner(value, event) {
        this.loading = value['loading']
      }
    },

    computed: {
      hasData() {
        return !!this.chartData; // && this.values.length > 1;
      },

      getTitle() {
        return this.name;
      },

      getHeight() {
        return this.chartHeight;
      },

      chartHeading() {
        return titleCase(this.name);
      },

      collapseID() {
        return this.name.toLowerCase().replace(" ", "-");
      },

      modalID() {
        return "modal-" + this.name;
      },

      modalDescID() {
        return "modal-description-" + this.name;
      },

      innerStyle() {
        const spacing = "20px 4px";
        return {
          height: `${CATEGORICAL_INSIGHT_HEIGHT}px`,
          width: `calc(100% - ${spacing} * 2)`,
          margin: spacing,
          position: "relative"
        };
      },

      selectOptions() {
        return Object.keys(this.values);
      },

      supportedCharts() {
        return [
          {label: 'bar', value: 'bar'},
          {label: 'column', value: 'column'},
          {label: 'line', value: 'spline'},
          {label: 'area', value: 'areaspline'},
          {label: 'pie', value: 'pie'}
          ];
      },

      widthColumns() {
        return (!!this.width) ? this.width : (this.values.length >= 2 && this.isString) || this.isObject || this.isArray ? 2 : 1;
      },

      chartOptions() {
        // this.chartData = (!!this.selectedItem) ? this.chartData : this.values;
        // this.chartData = (!!this.chartFilterData) ? this.chartFilterData : this.chartData;
        if (!this.hasData) {
          return {};
        }
        else {
          this.exportOptions = this.defaultExportOptions();
          if (this.defaultChart === "map") {
            return this.mapChartOptions;
          }else if (this.defaultChart === "stacked_column") {
            return this.stackedBarChartOptions;
          }else if (this.defaultChart === "heat_map") {
            return this.heatMapChartOptions;
          } else if (this.drilldown && this.subtitle) {
            return this.drillDownChartOptions;
          } else if (this.grouped) {
            return this.groupedBarChartOptions;
          } else if (this.isObject) {
            this.chartTitle = (!!this.chartTitle) ? this.chartTitle : this.name + " - " + Object.keys(this.chartData)[0];
            this.chartData = (!!this.chartData && this.chartData.length > 0) ? this.chartData : this.chartData[Object.keys(this.chartData)[0]];
            return this.nestedBarChartOptions;
          } else if (this.xlabeltype && this.xlabeltype === "date" && this.growthrate) return this.barChartOptions2;
          else if (this.chartData.length > 2 && this.growthrate) return this.barChartOptions2;
          else if (this.chartData.length === 1 && this.growthrate) return this.barChartOptions2;
          else if (this.xlabeltype && this.xlabeltype === "date") return this.barChartOptions;
          else if (this.chartData.length > 2) return this.barChartOptions;
          else if (this.chartData.length === 1) return this.barChartOptions;
          return this.pieChartOptions;
        }
      },

      nestedBarChartOptions() {
        let categories = this.chartData.map(bin => bin[0]);
        let chart = this.isString || this.isObject ? 'bar' : 'column';
        this.chartType = (!!this.chartType) ? this.chartType : chart;
        return {
          chart: {
            type: this.chartType
          },
          title: {
            text: titleCase(this.chartTitle)
          },
          xAxis: {
            categories: categories,
            crosshair: true
          },
          yAxis: {
            min: 0,
            title: {
              text: this.title
            }
          },
          tooltip: {
            headerFormat: '',
            pointFormat: '<b>{point.y:.1f}</b>',
            footerFormat: '',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '<b>{point.y}</b>'
              }
            }
          },
          series: [{
            showInLegend: false,
            name: titleCase(this.name),
            data: this.chartData.map(point => point[1])
          }],
          exporting: this.exportOptions
        };
      },

      stackedBarChartOptions() {
        let series = [];
        let xKeys = [];

        series = this.chartData["series"]
        xKeys = this.chartData["xkeys"]

        this.chartType = (!!this.chartType) ? this.chartType : 'bar';
        return {
          chart: {
            type: "column"
          },
          title: {
            text: titleCase(this.name)
          },
          xAxis: {
            categories: xKeys,
            crosshair: true,
            title: {
              text: `${this.ylabel}`
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: `${this.xlabel}`
            },
            reversedStacks: false
          },
          tooltip: {
            headerFormat: '<b>{point.x}</b><br/>',
            pointFormat: 'Cohort_{series.name}: {point.y}<br/>'
            // pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
        },
          plotOptions: {
            column: {
            stacking: 'normal',
            // dataLabels: {
            //     enabled: true
            // }
        }
          },
          series: series,
          exporting: this.exportOptions
        };
      },

      heatMapChartOptions() {
        let series = this.chartData["series_data"]
        let x_categories = this.chartData["x_categories"]
        let y_categories = this.chartData["y_categories"]
        let context = this

        return {
          chart: {
            type: "heatmap"
          },
          title: {
            text: titleCase(this.name)
          },
          xAxis: {
            categories: x_categories,
            opposite: true,
            title: {
              text: `${this.ylabel}`
            }
          },
          yAxis: {
            categories: y_categories,
            title: {
              text: `${this.xlabel}`
            },
            reversed: true
          },
          colorAxis: {
            min: 1,
            minColor: '#AAD4F2',
            maxColor: '#00AAFF',
          },
          legend: {
            enabled: false
          },
          tooltip: {
            formatter: function () {
            //  No of transacting cohorts for
            //   return '<b>' + this.point.value + '</b> customers from <b> Cohort_'  +
            //     context.getPointCategoryName(this.point, 'y') + '</b><br> performed transactions in ' + '<b>' +
            //     context.getPointCategoryName(this.point, 'x') + '</b>';
            return '<b>' + context.getPointCategoryName(this.point, 'x') + '</b> <br>' +
                'Cohort_' + context.getPointCategoryName(this.point, 'y') + ': <b>' + this.point.value + '</b>';
        }
        },
          series: [{
            borderWidth: 1,
            data: series,
            dataLabels: {
              enabled: true,
              color: '#ffffff',
              style: {
                    textOutline: 'none'
                },
              formatter () {
                let lb = context.dataValueLabel
                console.log("lb", lb)
                if (lb == null) {
                  return this.point.value
                } else {
                  return this.point.value  + lb
                }
      			}
            }
          }],
          exporting: this.exportOptions
        };
      },

      barChartOptions() {
        let categories = this.chartData.map(bin => bin[0]);
        let chart = (this.isString || typeof categories[0] === 'string') ? 'bar' : 'column';
        if (this.defaultChart === "column") {
          chart = this.defaultChart;
        }

        this.chartType = (!!this.chartType) ? this.chartType : chart;
        let context = this;
        return {
          // let test = this;
          chart: {
            type: this.chartType
          },
          title: {
            text: titleCase(this.name)
          },
          xAxis: {
            categories: categories,
            crosshair: true,
            title: {
              text: `${this.xlabel}`
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: `${this.ylabel}`
            }
          },
          tooltip: {
            headerFormat: '',
            pointFormat: '<b>{point.y:.1f}</b>',
            footerFormat: '',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                // format: '<b>{point.y}</b>'
                formatter: function() {
                  return context.abbreviateNumber(this.y)
                }
              }
            },
            bar: {
              pointPadding: 0.2,
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                formatter: function() {
                  return context.abbreviateNumber(this.y)
                }
              }
            }
          },
          series: [{
            showInLegend: false,
            name: titleCase(this.name),
            data: this.chartData.map(point => point[1])
          }],
          exporting: this.exportOptions
        };
      },

      groupedBarChartOptions() {
        let categories = this.chartData.categories;
        let chart = (this.isString || typeof categories[0] === 'string') ? 'bar' : 'column';
        let d = this.chartData.data;
        d[0].name = d[0].name.replace(this.currency_placeholder, this.currency.currency_name)
        d[0].name = d[0].name.replace(this.currency_symbol_placeholder, this.currency.currency_symbol)
        let yaxis = [{"min": 0, "title": {"text": d[0].name}}];
        d[0]["yAxis"] = 0;
        for (let i=1; i<d.length; i++) {
          d[i].name = d[i].name.replace(this.currency_placeholder, this.currency.currency_name)
          d[i].name = d[i].name.replace(this.currency_symbol_placeholder, this.currency.currency_symbol)
          yaxis.push({"min": 0, "title": {"text": d[i].name}, "opposite": true});
          d[i]["yAxis"] = i;
        }
        if (this.defaultChart === "column") {
          chart = this.defaultChart;
        }
        let context = this;
        this.chartType = (!!this.chartType) ? this.chartType : chart;
        return {
          chart: {
            type: this.chartType
          },
          title: {
            text: titleCase(this.name)
          },
          xAxis: {
            categories: categories,
            crosshair: true,
            title: {
              text: `${this.xlabel}`
            }
          },
          yAxis: yaxis,
          tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            // pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            //   '<td style="padding:0"><b>{point.y}</b></td></tr>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
              '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                formatter: function() {
                  return context.abbreviateNumber(this.y)
                }
              }
            },
            bar: {
              useHTML: true,
              pointPadding: 0.2,
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                formatter: function() {
                  return context.abbreviateNumber(this.y);
                }
              }
            },
            pie: {
              showInLegend: true,
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                formatter: function() {
                  var sliceIndex = this.point.index;
                  var sliceName = this.series.chart.axes[0].categories[sliceIndex];
                  return sliceName
                }
              }
            }
          },
          series: this.chartData.data,
          exporting: this.exportOptions
        };
      },

      pieChartOptions() {
        this.chartType = (!!this.chartType) ? this.chartType : 'pie';
        let context = this
        return {
          chart: {
            type: this.chartType,
          },
          title: {
            text: titleCase(this.name)
          },
          tooltip: {
            pointFormat: '<p>Count: <b>{point.y}</b><br/>Percentage: <b>{point.percentage:.1f}%</b></p>'
          },
          plotOptions: {
            pie: {
              showInLegend: true,
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                formatter: function() {
                  return context.abbreviateNumber(this.y)
                }
              }
            }
          },
          legend: {
            itemDistance: 5,
            itemStyle: {
              fontSize: '11px'
            }
          },
          series: [{
            name: titleCase(this.name),
            colorByPoint: true,
            data: this.chartData.map(point => ({
              name: maybeMissingValueLabel(point[0]),
              y: point[1]
            }))
          }],
          exporting: this.exportOptions
        };
      },

      drillDownChartOptions() {
        let series = this.chartData;
        series = this.generateData(series)
        let seriesData = series[0];
        let drillDownData = series[1]
        let newSeries = seriesData;
        let chart = "column"
        this.chartType = (!!this.chartType) ? this.chartType : chart;
        return {
          chart: {
            type: this.chartType
          },
          title: {
            text: titleCase(this.name)
          },
          subtitle: {
            text: `${this.subtitle}`
          },
          accessibility: {
            announceNewData: {
              enabled: true
            }
          },
          xAxis: {
            type: 'category',
            title: {
              text: `${this.xlabel}`
            }
          },
          yAxis: {
            title: {
              text: `${this.ylabel}`
            }
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.label}'
              }
            }
          },
          tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>'
          },
          series: [newSeries],
          exporting: this.exportOptions,
          drilldown: {
            series: drillDownData
          }
        };
      },

      mapChartOptions() {
        return {
          chart: {
            map: "myMapName",
            type: "map"
          },
          title: {
            text: this.name
          },
          legend: {
            enabled: false
          },
          mapNavigation: {
            enabled: true
          },

          colorAxis: {
            min: 1,
            type: 'logarithmic',
            minColor: '#AAD4F2',
            maxColor: '#00AAFF',
            // minColor: '#EEEEFF',
            // maxColor: '#000022',
            stops: [
              [0, '#AAD4F2'],
              // [0, '#EFEFFF'],
              // [0.67, '#4444FF'],
              [1, '#00AAFF']
              // [1, '#000022']
            ]
          },
          yAxis: {
            gridLineWidth: 0,
             minorGridLineWidth: 0,
            minorTickWidth: 0,
            labels: {
              enabled: false
            },
             title: {
              text: ""
            }
          },
          xAxis: {
            gridLineWidth: 0,
             minorGridLineWidth: 0,
            minorTickWidth: 0,
            minorTickLength: 0,
            labels: {
              enabled: false
            }
          },
          series: [
            {
              name: this.name,
              states: {
              },
              dataLabels: {
                enabled: true,
                color: '#FFFFFF',
                format: "{point.name}"
              },
              data: this.chartData
            }
          ],
          exporting: this.exportOptions
        }

      },

      barChartOptions2() {
        let categories = this.chartData.map(bin => bin[0]);
        let ydata = this.chartData.map(point => point[1])
        let ydata2 = [0]
        let prev = 0
        ydata.forEach(d => {
          if (prev) {
            ydata2.push(((d - prev)/prev)*100)
            prev = d
          } else {
            prev = d
          }
          })
        let chart = (this.isString || typeof categories[0] === 'string') ? 'bar' : 'column';
        if (this.defaultChart === "column") {
          chart = this.defaultChart;
        }

        this.chartType = (!!this.chartType) ? this.chartType : chart;
        let context = this;
        return {
          chart: {
            type: this.chartType
          },
          title: {
            text: titleCase(this.name)
          },
          xAxis: {
            categories: categories,
            crosshair: true,
            title: {
              text: `${this.xlabel}`
            }
          },
          yAxis: [{
            min: 0,
            title: {
              text: `${this.ylabel}`
            }
          }, { // Secondary yAxis
            title: {
              text: "Growth Rate(%)",
            },
            opposite: true
          }],
          // tooltip: {
          //   crosshairs: true,
          //   shared: true
          // },
          tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            // pointFormat: '<b>{point.y}</b>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
              '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                // format: '<b>{point.y}</b>'
                formatter: function() {
                  return context.abbreviateNumber(this.y)
                }
              }
            },
            bar: {
              pointPadding: 0.2,
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                formatter: function() {
                  return context.abbreviateNumber(this.y)
                }
              }
            }
          },
          series: [{
            showInLegend: false,
            name: titleCase(this.name),
            data: this.chartData.map(point => point[1])
          }, {
            name: "Growth Rate",
            type: 'line',
            data: ydata2,
            yAxis: 1,
            color: 'orange',
            marker: {
              enabled: false
            }
          }],
          exporting: this.exportOptions
        };
      },
    }
  };
</script>

<style scoped lang="css">
  .fullscreen-modal {
    width: 100% !important;
    height: 100% !important
  }

  /deep/ .modal-dialog {
    max-width: 100% !important;
    margin-top: 0 !important;
    margin: 0 !important;
    top: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    height: 100vh !important;
    max-height: 150vh !important;
    display: flex !important;
    position: relative !important;
    z-index: 100000 !important
  }

  @media (min-width: 1200px) {
    .modal-xl {
      max-width: auto !important;
    }
  }

  @media (min-height: 600px) {
    .modal-xl {
      max-height: 80% !important;
    }
  }

  @media (min-width: 992px) {
    .modal-lg, .modal-xl {
      max-width: auto !important;
    }
  }

  @media (min-width: 992px) {
    .modal-dialog {
      max-width: auto !important;
    }
  }
  .card-style {
    margin: 0
  }
  .card-header-padding {
    padding: 0
  }

  .insight-cols-1 {
    width: 25%;
    max-width: 100%;
    z-index: 0
  }
  .insight-cols-2 {
    width: 50%;
    max-width: 100%;
    z-index: 0
  }
  .insight-cols-3 {
    width: 75%;
    max-width: 100%;
    z-index: 0
  }
  .insight-cols-4 {
    width: 100%;
    max-width: 100%;
    z-index: 0
  }

  @media (max-width: 480px) {
    .insight-cols-1 {
      width: 50%;
      z-index: 0
    }
    .insight-cols-2 {
      width: 100%;
      z-index: 0
    }
    .insight-cols-3 {
      width: 150%;
      z-index: 0
    }
    .insight-cols-4 {
      width: 200%;
      z-index: 0
    }
  }

  @media (max-width: 320px) {
    .insight-cols-1, .insight-cols-2, .insight-cols-3, .insight-cols-4 {
      width: 100%;
      z-index: 0
    }
  }

</style>
